import React, { useCallback, useMemo } from 'react';
import { get, isEqual } from 'lodash';

import {
	useClassNames,
	classNames,
} from '@common';

import {
	Popover,
} from '@components';

import './PopoverSelect.scss';

interface PopoverSelectProps<T> {
	onChange?: (value: T) => void,
	// 	textName?: string | keyof T,
	textName: string,
	options: T[],
	value: T,

	className?: string,
	disabled?: boolean,
}

function PopoverSelect<T>(props: PopoverSelectProps<T>): JSX.Element {
	const {
		className,
		onChange,
		textName,
		options,
		value,
		disabled,
	} = props;

	const handleChange = useCallback((option: T) => () => {
		onChange(option);
	}, [onChange]);

	const optionsView = useMemo((): JSX.Element[] => {
		return options.map((option, i) => {
			const
				isSelected = isEqual(option, value),
				classes = classNames(
					'popover-select__option',
					isSelected && 'selected',
				);

			return (
				<div
					onClick={handleChange(option)}
					className={classes}
					key={i}
				>
					{textName ? get(option, textName) : option}
				</div>
			);
		});
	}, [options, value, handleChange, textName]);

	const classes = useClassNames(
		'popover-select',
		className,
	);

	return (
		<div className={classes}>
			<Popover content={optionsView} disabled={disabled}>
				{textName ? get(value, textName) : value}
			</Popover>
		</div>
	);
}

export {PopoverSelect};